import React from 'react';
import clsx from 'clsx';
import { MenuBar } from '@brighterionai/br-ui';
import useBreadcrumbs from 'Hooks/useBreadcrumbs';
import { getUTCTimeZoneOffset, timeZone } from '@brighterion/utils/date';
import Breadcrumbs from './Breadcrumbs';
import styles from './SubNav.css';

const SubNav: React.FC = () => {
    const { breadcrumbs } = useBreadcrumbs() as BreadcrumbWrapper;
    const timeZoneText = `${timeZone?.replace(/_/g, ' ') ?? ''} (UTC ${getUTCTimeZoneOffset()})`;

    if (breadcrumbs.length === 0) return null;
    return (
        <>
            <div className={clsx(styles.pageLocationBar)}>
                <MenuBar
                    id='page-title-bar'
                    leftAlignedMenuItems={[<Breadcrumbs key='breadcrumbs' />]}
                    rightAlignedMenuItems={[`Timezone: ${timeZoneText}`]}
                />
            </div>
        </>
    );
};

export default SubNav;
